<template>
  <ul class="flex flex-col gap-6 mb-6" data-testid="comments-list" v-if="list.length">
    <Message v-for="comment in list" :key="comment.id" :comment="comment" :tribute-options="props.tributeOptions" />
  </ul>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useCommentsStore } from '@/modules/viewer/store/useCommentsStore';
import Message from './Message.vue';

const props = defineProps<{
  tributeOptions?: any;
}>();

const commentsStore = useCommentsStore();
const { list } = storeToRefs(commentsStore);
</script>
